<div class="movie-credits-wrap movie-detail-section" [class.canCollapse]="canCollapse" [class.collapsed]="collapsed">
  <div
    class="header-msg title"
    (click)="toggleCollapse()"
    [attr.data-translate]="'movie.menu.credits'"
    i18n="@@movie.menu.credits"
  >
    Credits
  </div>
  <div class="movie-credits credits-content">
    <!-- Standar Crew-->
    <ng-container *ngIf="!customCrew">
      <ul class="info-list">
        <ng-container *ngFor="let credit of crewListing">
          <li *ngIf="credit" [ngClass]="credit.roleClass + '-list'">
            <div class="subtitle" [attr.data-translate]="credit.role">
              <div class="subtitle-header">{{ credit.role | translate }}<span class="semicolon">:</span></div>
            </div>
            <div class="text">
              <span
                *ngFor="let star of credit.starList"
                class="crew {{ star.customClass }}"
                [pTooltip]="star?.episodestooltip"
                tooltipPosition="top"
              >
                <a *ngIf="star.urlRedirect" [routerLink]="star.urlRedirect">{{ star.name }}</a>
                <ng-container *ngIf="!star.urlRedirect">{{ star.name }}</ng-container>
                <span class="comma">, </span>
              </span>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="producingCompanies">
          <li class="production-companies">
            <div class="subtitle" [attr.data-translate]="'crew.role.production-company'">
              <span i18n="@@crew.role.production-company">Production company</span> <span class="semicolon">:</span>
            </div>
            <div class="text">{{ producingCompanies }}</div>
          </li>
        </ng-container>
      </ul>
    </ng-container>
    <!-- Custom Crew-->
    <ng-container *ngIf="customCrew">
      <ul class="info-list custom-crew-members">
        <li class="custom-crew-item-list" *ngFor="let credit of customCrew" [attr.data-key]="credit[0] | kebabCase">
          <div
            class="subtitle"
            [attr.data-translate]="'custom.movie.role.' + (credit[0] | kebabCase)"
            [attr.data-notranslate]="true"
          >
            <span>{{ credit[0] }}</span>
            <span class="semicolon">:</span>
          </div>
          <div class="text">{{ credit[1] }}</div>
        </li>
        <ng-container *ngIf="producingCompanies">
          <li class="production-companies">
            <div class="subtitle" [attr.data-translate]="'crew.role.production-company'">
              <span i18n="@@crew.role.production-company">Production company</span>
              <span class="semicolon">:</span>
            </div>
            <div class="text">{{ producingCompanies }}</div>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </div>
</div>
